import { Injectable } from '@angular/core';
import {Storage} from "@ionic/storage";
import {NativeStorage} from "@ionic-native/native-storage";
import {MyApp} from "../../app/app.component";

@Injectable()
export class LocalStorage {

  constructor(public storage: Storage, public ns: NativeStorage) {

  }

  async get(key: string) {
    if (MyApp.os != "browser") {
      return this.ns.getItem(key);
    } else {
      //return this.storage.get(key);
      return new Promise(async (resolve) => {
        console.log("Getting key ",key," from local storage");
        let v = await this.storage.get(key);
        console.log("Result for key ",key," from local storage : ",v);
        resolve(JSON.parse(v));
      });
    }
  }

  set(key: string, value: any){
    if (MyApp.os != "browser") {
      return this.ns.setItem(key,value);
    } else {
      return this.storage.set(key,JSON.stringify(value));
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/local-storage/local-storage.ts